<template>
    <div class="find-a-doctor-card card">
        <div class="find-a-doctor-card__inner">
            <div class="find-a-doctor-card__top">
                <a :href="`/${data.url}`" class="find-a-doctor-card__image-wrapper" @click="handleClick('avatar', $event)">
                    <img :src="data.image" class="find-a-doctor-card__image" :alt="data.alt" v-if="data.image">
                    <span class="find-a-doctor-card__link">View Profile</span>
                </a>

                <div class="find-a-doctor-card__info">
                    <a :href="`/${data.url}`" class="find-a-doctor-card__heading" @click="handleClick('title', $event)">{{ data.title }}</a>

                    <div class="find-a-doctor-card__title">{{ data.position }}</div>

                    <div class="find-a-doctor-card__subtitle">{{ data.additional_titles }}</div>

                    <div class="find-a-doctor-card__address" v-html="address" />
                    <!-- TODO: Add urls -->

                    <a href="/locations" class="find-a-doctor-card__locations-link" v-if="data.locations.length > 1" @click="handleClick('locations', $event)">
                        View All Locations
                    </a>
                </div>
            </div>
            <div class="find-a-doctor-card__bottom">
                <div class="find-a-doctor-card__actions">
                    <template v-if="data.email_address">
                        <a
                            :href="`mailto:${data.email_address}`"
                            class="find-a-doctor-card__button button"
                            @click="handleClick('email', $event)"
                        >
                            Email Researcher
                        </a>
                    </template>
                    <a :href="`tel:+${data.phone_number}`" class="find-a-doctor-card__phone-number" v-if="data.phone_number" @click="handleClick('phone_number', $event)">{{ data.phone_number }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { swiftypeClickMixin } from '../../../scripts/mixins';

export default {
    name: 'personnel',
    props: ['data', 'requestId', 'query'],
    mixins: [swiftypeClickMixin],
    computed: {
        address() {
            let address = '';

            if (this.data.address_parts) {
                const location = this.data.locations.length ? this.data.locations[0] : null;
                let parts = JSON.parse(this.data.address_parts);
                if (location && parts) {

                    address = `<strong>${location}</strong><br>${parts.street_number || parts.number} ${parts.route || parts.address}<br>`;

                    if (parts.suite) {
                        address += `${parts.suite}<br>`;
                    }

                    address += `${parts.locality || parts.city}, ${parts.administrative_area_level_1 || parts.state }, ${parts.postal_code || parts.postcode}`
                }
            }

            return address;
        }
    }
}
</script>
